import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/notices',
    name: 'NoticesView',
    component: () => import(/* webpackChunkName: "notices-view" */ '@/modules/process_support/notices/components/NoticesView'),
    meta: {
      moduleId: 'notices',
      preloads: ['rights/actingUserHasRight/WORK_Hinweise_bulk_löschen'],
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    props: true,
    beforeEnter: checkAuthenticated
  },
  {
    path: '/notices/:id',
    name: 'NoticeForm',
    component: () => import(/* webpackChunkName: "notice-form" */ '@/modules/process_support/notices/components/NoticeForm'),
    meta: {
      moduleId: 'notices',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/messages',
    name: 'MessagesView',
    component: () => import(/* webpackChunkName: "messages-view" */ '@/modules/process_support/messages/MessagesView'),
    meta: {
      moduleId: 'messages',
      preloads: ['rights/actingUserHasRight/WORK_Nachrichten_Bulk_Löschend'],
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    props: true,
    beforeEnter: checkAuthenticated
  },
  {
    path: '/messages/:id/answer',
    name: 'MessageAnswerForm',
    component: () => import(/* webpackChunkName: "message-answer-form" */ '@/modules/process_support/messages/MessageAnswerForm'),
    meta: {
      moduleId: 'messages',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/messages/:id',
    name: 'MessageForm',
    component: () => import(/* webpackChunkName: "message-form" */ '@/modules/process_support/messages/MessageForm'),
    meta: {
      moduleId: 'messages',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/tasks',
    name: 'TaskView',
    component: () => import(/* webpackChunkName: "tasks-view" */ '@/modules/process_support/tasks/components/TasksView'),
    props: true,
    meta: {
      moduleId: 'tasks',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/tasks/:id',
    name: 'TaskForm',
    component: () => import(/* webpackChunkName: "task-form" */ '@/modules/process_support/tasks/components/TaskForm'),
    meta: {
      moduleId: 'tasks',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
]
